<div class="card-container">
    <div class="selectionPageWrapper" *ngIf="sectiontoShow === 'selectionPage'">
        <mat-card>
            <mat-card-title class="inner-title">
                <h2>You are not currently an Active MCT</h2>
            </mat-card-title>

            <p class="selectionPage-text">
                You’ve been an important part of the Microsoft Certified Trainer community, and we appreciate your
                contributions. To stay connected, you can either renew your MCT status or join the community as an
                Alumni.
            </p>

            <div class="card-split-container">
                <div class="card-left-section">
                    <span>
                        <p class="section-title">MCT</p>
                        <p class="section-subtitle">MCT Fee</p>
                    </span>
                    <ul class="feature-list">
                        <li class="feature-item">
                            <mat-icon class="checkmark-icon">check</mat-icon>
                            <span>MCT Lounge</span>
                        </li>
                        <li class="feature-item">
                            <mat-icon class="checkmark-icon">check</mat-icon>
                            <span>VS Subscription</span>
                        </li>
                        <li class="feature-item">
                            <mat-icon class="checkmark-icon">check</mat-icon>
                            <span>Learning Download Center</span>
                        </li>
                        <li class="feature-item">
                            <mat-icon class="checkmark-icon">check</mat-icon>
                            <span>Labs Access</span>
                        </li>
                    </ul>
                    <div class="button-container">
                        <button (click)="renewMCT()" type="button" mat-flat-button class="full-width-btn">
                            Become an MCT
                        </button>
                    </div>
                </div>

                <div class="card-right-section">
                    <p class="section-title">Alumni</p>
                    <p class="section-subtitle">Free</p>
                    <ul class="feature-list">
                        <li class="feature-item">
                            <mat-icon class="checkmark-icon">check</mat-icon>
                            <span>MCT Lounge</span>
                        </li>
                    </ul>
                    <div class="button-container">
                        <button (click)="renewAlumni()" type="button" mat-flat-button class="full-width-btn">Become an Alumni</button>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>

    <div class="selectionPageWrapper" *ngIf="sectiontoShow === 'alumniSection'">

        <mat-card-title class="center-title">
            <h2>Alumni Application Form</h2>
        </mat-card-title>

        <mat-card class="alumni-form-card">
            <form [formGroup]="alumniForm" (ngSubmit)="submitAlumniForm()">
                <div>

                    <div class="subscription-details-wrapper">
                        <span class="subscription-content-label">Current MCT Subscription</span>
                        <div class="subscription-details">
                            <div>
                                <p>ACTIVE SINCE</p>
                                <p>{{activeSince ? (activeSince | date:'MMMM dd, yyyy':'UTC' ): '-'}}</p>
                            </div>
                            <div>
                                <p>END DATE</p>
                                <p>{{mctSubscriptionEndDate ? (mctSubscriptionEndDate | date:'MMMM dd, yyyy':'UTC' ):
                                    '-'}}
                                </p>
                            </div>
                        </div>
                    </div>

                    <mat-form-field>
                        <input type="text" placeholder="First Name" matInput formControlName="firstname" />
                        <mat-error
                            *ngIf="alumniForm.get('firstname')?.hasError('required') && (alumniForm.get('firstname')?.dirty || alumniForm.get('firstname')?.touched || alumniFormSubmitted)">
                            First Name is required
                        </mat-error>
                        <mat-error *ngIf="alumniForm.get('firstname')?.hasError('pattern') && (alumniForm.get('firstname')?.dirty || alumniForm.get('firstname')?.touched || alumniFormSubmitted)">
                            First name can contain letters only
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input type="text" placeholder="Last Name" matInput formControlName="lastname" />
                        <mat-error
                            *ngIf="alumniForm.get('lastname')?.hasError('required') && (alumniForm.get('lastname')?.dirty || alumniForm.get('lastname')?.touched || alumniFormSubmitted)">
                            Last Name is required
                        </mat-error>
                        <mat-error *ngIf="alumniForm.get('lastname')?.hasError('pattern') && (alumniForm.get('lastname')?.dirty || alumniForm.get('lastname')?.touched || alumniFormSubmitted)">
                            Last name can contain letters only
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                        <input type="text" placeholder="Email" matInput formControlName="email" />
                        <mat-error
                            *ngIf="alumniForm.get('email')?.hasError('required') && (alumniForm.get('email')?.dirty || alumniForm.get('email')?.touched || alumniFormSubmitted)">Email
                            required</mat-error>
                    </mat-form-field>

                    <div class="checkbox-section-wrapper">
                        <span class="concent_label">What prompted your transition to the Alumni program?</span>
                        <p class="reason-description">
                            Your feedback matters. Please share your reason(s) for switching to the MCT Alumni program.
                            Please Note: MCT Alumni benefits differ from the benefits provided to MCTs. Please click
                            here to <a
                                href="https://learn.microsoft.com/en-us/credentials/certifications/mct-certification#mct-alumni-program"
                                target="_blank" rel="noopener noreferrer">learn more</a>
                        </p>
                        <div class="checkbox-container">
                            <mat-checkbox *ngFor="let reason of reasonOptions"
                                [checked]="isReasonSelected(reason.value)"
                                (change)="onReasonChange($event, reason.value)" class="checkbox-item">
                                {{reason.label}}
                            </mat-checkbox>
                        </div>
                        <mat-error
                            *ngIf="alumniReasonsControl?.invalid && (alumniReasonsControl?.dirty || alumniReasonsControl?.touched || alumniFormSubmitted)">
                            Please select at least one reason for becoming an alumni
                        </mat-error>
                    </div>

                    <div>
                        <mat-form-field>
                            <textarea matInput placeholder="Description" #textarea maxlength="500"
                                formControlName="alumniText"></textarea>
                            <mat-hint align="end">{{ textarea.value.length }} / 500</mat-hint>
                            <mat-error
                                *ngIf="!alumniForm.get('alumniText')?.valid && alumniForm.get('alumniText')?.touched && alumniForm.get('alumniText')?.errors?.['required']">Description
                                is Required !</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="aggrement-container">
                        <p style="font-size: 13px; color: #595959; margin-bottom: 8px;margin-left:10px">
                                    <em>Note: You must review the MCT Alumni Agreement through the link below before you can check the box to accept it.</em>
                        </p>
                        <div class="checkbox-horizontal-container">
                            <mat-checkbox class="checkbox-item" formControlName="mctAlumniAgreement"
                                [(ngModel)]="isAlumniCheckboxSelected" [ngClass]="{
                                        'is-invalid': !isAlumniCheckboxSelected && formSubmitted }"
                                id="alumniCheckbox">
                            </mat-checkbox>
                            By checking this box, I acknowledge that I have read and agree to the terms of the 
                            <a href="javascript:void(0)" (click)="alumniagrementDoc()" 
                                (keydown.enter)="alumniagrementDoc(); $event.stopPropagation()" 
                                [attr.aria-label]="'MCT Alumni Agreement (downloads PDF file, 150KB)'">
                                MCT Alumni Agreement
                            </a>
                        </div>
                        <mat-error class="is-invalid no-top-margin"
                            *ngIf="!isAlumniCheckboxSelected && alumniFormSubmitted">
                            You must accept the Agreement to continue
                        </mat-error>
                    </div>
                </div>

                <div class="btn-submit-container">
                    <button (click)="onCancel()" type="button" class="blue-border-btn" mat-stroked-button>
                        Previous
                    </button>
                    <button [disabled]="disablesubmitBtn" type="button" class="submitButton" mat-flat-button (click)="submitAlumniForm()">
                        Submit
                    </button>
                </div>
            </form>
        </mat-card>
    </div>

    <div class="selectionPageWrapper" *ngIf="sectiontoShow === 'mctReinstatementSection'">

        <mat-card-title class="center-title">
            <h2>Reinstatement Form (Instructional Skills Assessment)</h2>
        </mat-card-title>

        <mat-card>
            <mat-stepper linear #stepperHorLin [orientation]="(stepperOrientation | async)!"
                id="linearHorizontalStepper">

                <ng-template matStepperIcon="edit" let-index="index">
                    <span aria-hidden="true"> {{ index + 1 }}</span>
                </ng-template>


                <mat-step [stepControl]="reinstatementStepOne">
                    <form [formGroup]="reinstatementStepOne">
                        <ng-template matStepLabel>
                            <span aria-label="1 MCT Personal Info">MCT Personal Info</span>
                        </ng-template>

                        <div class="grid-layout">
                            <div class="form-row">
                                <mat-form-field class="form-field-flex">
                                    <input type="text" placeholder="First Name*" matInput formControlName="firstname" />
                                    <mat-error
                                        *ngIf="!reinstatementStepOne.get('firstname')?.valid && reinstatementStepOne.get('firstname')?.touched && reinstatementStepOne.get('firstname')?.errors?.required">
                                        First name is required
                                    </mat-error>

                                    <mat-error *ngIf="reinstatementStepOne.get('firstname')?.hasError('pattern') && (reinstatementStepOne.get('firstname')?.dirty || reinstatementStepOne.get('firstname')?.touched || reinstatementStepOne.get('firstname')?.errors?.required)">
                                        First name can contain letters only
                                    </mat-error>

                                </mat-form-field>
                                <mat-form-field class="form-field-flex">
                                    <input type="text" placeholder="Last Name*" matInput formControlName="lastname" />
                                    <mat-error
                                        *ngIf="!reinstatementStepOne.get('lastname')?.valid && reinstatementStepOne.get('lastname')?.touched && reinstatementStepOne.get('lastname')?.errors?.required">
                                        Last name is required
                                    </mat-error>

                                    <mat-error *ngIf="reinstatementStepOne.get('lastname')?.hasError('pattern') && (reinstatementStepOne.get('lastname')?.dirty || reinstatementStepOne.get('lastname')?.touched || reinstatementStepOne.get('lastname')?.errors?.required)">
                                        Last name can contain letters only
                                    </mat-error>

                                </mat-form-field>
                            </div>

                            <mat-form-field>
                                <input type="text" placeholder="Email*" matInput formControlName="email" />
                                <mat-error
                                    *ngIf="!reinstatementStepOne.get('email')?.valid && reinstatementStepOne.get('email')?.touched && reinstatementStepOne.get('email')?.errors?.required">
                                    Email is required</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <input type="text" placeholder="Contact Email" matInput formControlName="alternateEmail" aria-label="Contact Email" />
                                <mat-error
                                    *ngIf="(reinstatementStepOne.get('alternateEmail')?.touched) && reinstatementStepOne.get('alternateEmail')?.hasError('invalidEmail')">
                                    Please enter a valid MCT email address
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select placeholder="Preferred Language*" formControlName="language">
                                    <mat-option *ngFor="let option of languageList" [value]="option.name">
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="!reinstatementStepOne.get('language')?.valid && reinstatementStepOne.get('language')?.touched && reinstatementStepOne.get('language')?.errors?.required">
                                    Select the Language</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select placeholder="Country*" formControlName="country"
                                    (selectionChange)="onCountryChange($event)">
                                    <mat-option *ngFor="let option of countryList" [value]="option.countryName">
                                        {{ option.countryName }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="!reinstatementStepOne.get('country')?.valid && reinstatementStepOne.get('country')?.touched && reinstatementStepOne.get('country')?.errors?.required">
                                    Select the Country</mat-error>
                            </mat-form-field>

                            <mat-form-field>
                                <mat-select placeholder="Timezone*" formControlName="timezone">
                                <mat-option *ngFor="let option of timezoneList" [value]="option.timeZone">
                                    {{ '(GMT' + option.utcOffset + ') ' + option.displayName }}
                                </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!reinstatementStepOne.get('timezone')?.valid && reinstatementStepOne.get('timezone')?.touched && reinstatementStepOne.get('timezone')?.errors?.required">
                                                Select the Timezone</mat-error>
                            </mat-form-field>


                            <mat-form-field>
                                <mat-select placeholder="Employment Type*" formControlName="employmentType">
                                    <mat-option *ngFor="let option of employmentTypeList" [value]="option.value">
                                        {{ option.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="!reinstatementStepOne.get('employmentType')?.valid && reinstatementStepOne.get('employmentType')?.touched && reinstatementStepOne.get('employmentType')?.errors?.required">
                                    Select the Employment Type</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="step-action">
                            <button *ngIf="isFirstStepEnable" mat-stroked-button matStepperPrevious (click)="onCancel()"
                                id="linearStep1Previous" class="blue-border-btn">
                                Previous
                            </button>
                            <button mat-flat-button matStepperNext id="linearStep1Next" class="btn-clr" (click)="next()">
                                Next
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="reinstatementStepTwo">
                    <form [formGroup]="reinstatementStepTwo">
                        <ng-template matStepLabel>
                          <span aria-label="2 MCT Agreement">MCT Agreement</span>
                        </ng-template>
                        <div class="grid-layout">

                            <div class="topaz-checkbox-group-col agreement-section">
                                 <p class="agreement-note">
                                    <em>Note: You must review the MCT Program Agreement through the link below before you can check the box to accept it.</em>
                                 </p>
                                <div class="agreement-checkbox-wrapper">
                                  <div class="basic-checkboxes">
                                    <mat-checkbox matInput formControlName="mctAgreement"
                                        [(ngModel)]="isCheckboxSelected"
                                        [ngClass]="{ 'is-invalid': !isCheckboxSelected && formSubmitted}"
                                        id="requiredCheckbox">
                                    </mat-checkbox>
                                    <span class="agreement-text">By checking this box, I acknowledge that I have read and agree to the terms of the <a href="javascript:void(0)" (click)="agrementDoc()" (keydown.enter)="agrementDoc(); $event.stopPropagation()" aria-live="polite" [attr.aria-label]="'MCT Program Agreement (downloads PDF file, 150KB)'">MCT Program Agreement</a></span>
                                  </div>
                                </div>
                                <mat-error class="is-invalid agrementErrorReinstatement" *ngIf="!isCheckboxSelected && formSubmitted">
                                    You must accept the Agreement to continue
                                </mat-error>
                            </div>
                        </div>
                        <div class="step-action">
                            <button mat-stroked-button matStepperPrevious class="blue-border-btn">
                                Previous
                            </button>
                            <button mat-flat-button class="btn-clr" matStepperNext id="linearStep2Next"
                                (click)="submitReInstatementForm()">Submit</button>
                        </div>
                    </form>
                </mat-step>
            </mat-stepper>
        </mat-card>
    </div>


    <mat-card class="help-wrapper">
        <mat-card-title class="help-title">
            Need help?
        </mat-card-title>
    </mat-card>

    <mat-card class="help-req-wrapper">
        <mat-card-content class="help-req-content">
            If you have any questions or need assistance, our support team is here to help.<br />
            <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a>
        </mat-card-content>
    </mat-card>
</div>